export default __webpack_public_path__ + "static/media/push-notification-logo.cc162810.svg";